<script>
	import { createEventDispatcher } from "svelte";
	import { block_special_characters, validate } from "$misc/actions";

	export let label = "Password";
	export let placeholder = "Password";
	export let feedback = false;
	export let value = "";

	export const trigger = () => {
		const node = document.querySelector(`#password`);
		node.focus();
		node.blur();
	};

	const dispatch = createEventDispatcher();
	const chars = new RegExp("[/\\\\'\"^£$%&*()[\\]}{@#`?!.;:><>,|=_+~¬-]");
	let show = false;

	const requirements = [
		{ cls: "length", validate: (value) => value.length > 8 },
		{ cls: "lowercase", validate: (value) => value.match(/[a-z]/) },
		{ cls: "uppercase", validate: (value) => value.match(/[A-Z]/) },
		{ cls: "numeric", validate: (value) => value.match(/[0-9]/) },
		{ cls: "special", validate: (value) => value.match(chars) },
	];

	const initialize = (node) => {
		const parent = node.parentElement;

		const get = (selector) => {
			return document.querySelector(selector);
		};

		const validate = ({ target }) => {
			const method = target.value ? "remove" : "add";

			const valid = requirements
				.map(({ cls, validate }) => {
					const method = validate(target.value) ? "add" : "remove";
					const element = get(`.field__password-requirements > span.${cls}`);

					element?.classList[method]("strike-through");

					if (method === "remove") {
						element?.classList.replace("text--muted", "text--orange");
					} else {
						element?.classList.replace("text--orange", "text--muted");
					}

					return validate(target.value) ? true : false;
				})
				.every((value) => value);

			parent.classList[method]("field--invalid");
			dispatch("validate", { valid, value: target.value });
		};

		const blur = ({ target }) => {
			const method = target.value ? "remove" : "add";

			const valid = requirements
				.map(({ cls, validate }) => {
					const method = validate(target.value) ? "add" : "remove";
					const element = get(`.field__password-requirements > span.${cls}`);

					element?.classList[method]("strike-through");

					if (method === "remove") {
						element?.classList.replace("text--muted", "text--orange");
					} else {
						element?.classList.replace("text--orange", "text--muted");
					}

					return validate(target.value) ? true : false;
				})
				.every((value) => value);

			parent.classList[method]("field--invalid");
			dispatch("validate", { valid, value: target.value });
		};

		node.addEventListener("input", validate);
		node.addEventListener("blur", blur);

		if (value) {
			node.dispatchEvent(new Event("blur"));
		}

		return {
			destroy() {
				node.removeEventListener("input", validate);
				node.removeEventListener("blur", blur);
			},
		};
	};

	$: icon = show ? "password1.svg" : "password2.svg";
	$: type = show ? "text" : "password";
</script>

<div class="form-group">
	<label for="password">{label}</label>

	<div class="input-group">
		<input
			{type}
			use:initialize
			use:validate={"text"}
			use:block_special_characters={{ custom: /[" ]/g }}
			class="form-control"
			id="password"
			name="password"
			{placeholder}
			autocomplete="off"
			{value}
			required
		/>
		<div class="input-group-append">
			<span
				class="input-group-text input-password-hide"
				on:click={() => (show = !show)}
			>
				<img alt="Show password" src="../icons/{icon}" />
			</span>
		</div>
	</div>

	{#if feedback}
		<div class="field__password-requirements mb-3">
			<span class="text text--muted length">8 characters minimum</span>
			<span class="text text--muted lowercase">1 lowercase character</span>
			<span class="text text--muted uppercase">1 uppercase character</span>
			<span class="text text--muted numeric">1 number character</span>
			<span class="text text--muted special">1 special character</span>
		</div>
	{/if}
</div>

<style lang="scss">
	.input-group-text {
		padding: 0rem 0.75rem;
	}

	.input-group-append img {
		height: 1.85em;

		@media only screen and (max-width: 768px) {
			height: 2.5em;
		}
		@media only screen and (max-width: 575px) {
			height: 4em;
		}
	}
</style>
